import { useCallback, useLayoutEffect, useMemo } from 'react';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { countNodes } from '@atlaskit/editor-common/count-nodes';
import { PluginPerformanceObserver } from '../../utils/performance/plugin-performance-observer';
export var usePluginPerformanceObserver = function usePluginPerformanceObserver(getEditorState, pluginInjectionAPI, dispatchAnalyticsEvent) {
  var onPluginObservation = useCallback(function (report) {
    var _pluginInjectionAPI$c;
    dispatchAnalyticsEvent({
      action: ACTION.TRANSACTION_DISPATCHED,
      actionSubject: ACTION_SUBJECT.EDITOR,
      eventType: EVENT_TYPE.OPERATIONAL,
      attributes: {
        report: report,
        participants: ((_pluginInjectionAPI$c = pluginInjectionAPI.current) === null || _pluginInjectionAPI$c === void 0 || (_pluginInjectionAPI$c = _pluginInjectionAPI$c.api().collabEdit) === null || _pluginInjectionAPI$c === void 0 || (_pluginInjectionAPI$c = _pluginInjectionAPI$c.sharedState.currentState()) === null || _pluginInjectionAPI$c === void 0 || (_pluginInjectionAPI$c = _pluginInjectionAPI$c.participants) === null || _pluginInjectionAPI$c === void 0 ? void 0 : _pluginInjectionAPI$c.size()) || 1
      }
    });
  }, [dispatchAnalyticsEvent, pluginInjectionAPI]);
  var getPluginNames = useCallback(function () {
    var _getEditorState;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (_getEditorState = getEditorState()) === null || _getEditorState === void 0 ? void 0 : _getEditorState.plugins.map(function (p) {
      return p.key;
    });
  }, [getEditorState]);
  var pluginPerformanceObserver = useMemo(function () {
    var state = getEditorState();
    return new PluginPerformanceObserver(function (report) {
      return onPluginObservation(report);
    }).withPlugins(function () {
      return getPluginNames();
    }).withNodeCounts(function () {
      return state ? countNodes(state) : {
        nodeCount: {},
        extensionNodeCount: {}
      };
    });
  }, [onPluginObservation, getPluginNames, getEditorState]);
  useLayoutEffect(function () {
    return function () {
      pluginPerformanceObserver.disconnect();
    };
  }, [pluginPerformanceObserver]);
};